import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { Id } from "@/convex/_generated/dataModel";
import DebitNotesForm from "@/components/invoices/debits/debit-notes-form";
import { Skeleton } from "@/components/ui/skeleton";

export const Route = createFileRoute("/_authenticated/invoices/debit-notes/$debitNoteId/edit")({
  component: EditDebitNotePage,
});

function EditDebitNotePage() {
  const { debitNoteId } = Route.useParams();
  const debitNote = useQuery(api.companies.debit_notes.queries.getDebitNoteById, {
    debitNoteId: debitNoteId as Id<"debit_notes">,
  });

  if (debitNote === undefined) {
    return (
      <div className="space-y-4 p-6">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-96 w-full" />
      </div>
    );
  }

  if (!debitNote) {
    return (
      <div className="flex flex-col items-center justify-center p-12">
        <p className="text-lg font-semibold text-muted-foreground">
          Nota de débito no encontrada
        </p>
      </div>
    );
  }

  // Documento fiscal: solo los borradores son editables. Emitidas/anuladas se
  // abren en modo solo lectura (misma vista, sin edición ni autosave).
  const readOnly = debitNote.status !== "draft";

  return (
    <RouteGuardPermissions
      permissions={[{ module: "debit_notes", actions: ["read", "update"] }]}
    >
      <DebitNotesForm debitNote={debitNote as any} readOnly={readOnly} />
    </RouteGuardPermissions>
  );
}
